import Vue from 'vue';
import Vuex from 'vuex';

// Import Store Plugins
import createPersistedState from 'vuex-persistedstate';
import kpiPlugins from './store/modules/stats/plugins';

// Import Modules
import AgentModule from './store/modules/agent';
import OrganizationModule from './store/modules/organization';
import SystemModule from './store/modules/system';
import AvatarModule from './store/modules/avatars';
import ReferencesModule from './store/modules/references';
import ContactsModule from './store/modules/contacts';
import ConversationsModule from './store/modules/conversations';
import InteractionsModule from './store/modules/interactions';
import ElementsModule from './store/modules/elements';
import EventTimingModule from './store/modules/event-timing';
import SettingsModule from './store/modules/settings';
import WindowModule from './store/modules/window';
import StatsModule from './store/modules/stats';
import WallboardModule from './store/modules/wallboard';
import DashboardModule from './store/modules/dashboard';
import NotificationsModule from './store/modules/notifications';
import BusinessProcessesModule from './store/modules/businessProcesses';
import CampaignsModule from './store/modules/campaigns';
import SupervisorModule from './store/modules/supervisor';

Vue.use(Vuex);

// eslint-disable-next-line import/no-named-as-default-member
export default new Vuex.Store({
  plugins: [
    createPersistedState({
      paths: [
        'AGENT.telephoneTerminals',
        'AGENT.registrationId',
        'CONVERSATIONS',
        'ELEMENTS.history',
        'ELEMENTS.elementAnsweredAt',
        'INTERACTIONS.dispositionCodes',
        'INTERACTIONS.recordings.recordingsByInteractionId',
        'INTERACTIONS.recordings.callRecordingStateByInteractionId',
        'INTERACTIONS.emails',
        'NOTIFICATIONS.notifications.system',
        'SETTINGS.softPhoneSettings',
        'REFERENCES.availableTimeZones',
        'REFERENCES.smsDetails',
        'REFERENCES.smtpDetails',
        'WINDOWS'
      ]
    }),
    kpiPlugins
  ],
  modules: {
    AGENT: AgentModule,
    ORGANIZATION: OrganizationModule,
    SYSTEM: SystemModule,
    AVATARS: AvatarModule,
    CONTACTS: ContactsModule,
    CONVERSATIONS: ConversationsModule,
    DASHBOARD: DashboardModule,
    INTERACTIONS: InteractionsModule,
    ELEMENTS: ElementsModule,
    EVENT_TIMING: EventTimingModule,
    NOTIFICATIONS: NotificationsModule,
    SETTINGS: SettingsModule,
    REFERENCES: ReferencesModule,
    STATS: StatsModule,
    WALLBOARD: WallboardModule,
    WINDOWS: WindowModule,
    BUSINESS_PROCESSES: BusinessProcessesModule,
    CAMPAIGNS: CampaignsModule,
    SUPERVISOR: SupervisorModule
  }
});
